import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useDispatch } from "react-redux";
import './trip-create.style.scss';
import { CitySelect } from "./city-select/city-select";
import { useSelector } from "react-redux";
import { selectedCitiesSelector, selectedStopsSelector } from "../../selector/trip-create.selector";
import { getCloneArray, isValid, isValidArray, getArrayfromString, checkActionAllowed } from "../../utils/utilities";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Form , Row, Button, Select, message , Col , InputNumber, Divider} from 'antd';
import { ShowCity } from "./create-trip-form/show-city";
import { RouteExcelComponent } from "./route-excel/route-excel.component";
import { loadingAction } from "../../actions/loading-actions";
import { TimeMethodStops } from "./time-method/time-method-stops";
import { setSelectedStops } from "../../actions/trip-create.actions";
import { ACTION_CREATE_TRIP_FROM_EXCEL } from "../../utils/constant";


export const TripCreateTimeRoot = (props) => {

    const dispatch = useDispatch();

    const {
        onCallBackSetDirections,
        masterCities,
        busesData,
        isTripCityCreated,
        addStop,
        tripScheduleId,
        setShowVerifyPage,
        setHeaderStep,
        stepDataVal,
        selectedSeatNumbers,
        setSelectedSeatNumbers,
        setShowSelectCity,
        showSelectCity,
        setDistance,
        setDuration,
        addStopComponent,
        customClassName,
        childRef,
        setCitiesChanged,
        busFormData,
        setAddStop,
        temporaryFlowState
    }= props;

    const selectedCities = useSelector(selectedCitiesSelector);
    const selectedStops = useSelector(selectedStopsSelector);
    
    const [form] = Form.useForm();
    const [tripCityHeader, setTripCityHeader] = useState("Create Trip");
    const [current, updateCurrent] = useState(1);
    const [busSelected,setBusSelected] = useState(null);
    let endReached = current == 1 ? true : false;
    const [formeDetails, updateForm] = useState({});
    const [excelRouteData, setExcelRouteData] = useState(null);

          // Initialize form with bus data from bus selection step
     useEffect(() => {
         if (busFormData) {
             // Find the selected bus from busesData
             const selectedBus = busesData.find(bus => bus.id === busFormData.bus_id);
             if (selectedBus) {
                 setBusSelected(selectedBus);
             }
             
             // Set form data with bus selection data
             updateForm(busFormData);
             
             // Set form values for the form fields
             form.setFieldsValue(busFormData);
         }
     }, [busFormData, busesData, form]);

    const setLoading = useCallback((bool) => {
        dispatch(loadingAction(bool));
    }, [dispatch]);

    const updateSelectedCity = useCallback((cityIndex, info, isBulkUpdate = false) => {
        let newArray;
        
        if (isBulkUpdate && Array.isArray(info)) {
            // Handle bulk update - replace entire array
            newArray = [...info];
        } else {
            // Handle single city update (existing logic)
            newArray = getCloneArray(selectedCities);
            
            if(isValid(info)){
                if(isValid(newArray[cityIndex])){
                    newArray[cityIndex] = info.data;
                }else{
                    newArray.push(info.data);
                }
            }else{
                newArray.splice(cityIndex,1);
            }
        }
        
        onCallBackSetDirections([...newArray]);
        setCitiesChanged(true);
    }, [selectedCities, onCallBackSetDirections, setCitiesChanged]);

    const layout = {
        labelCol: { span: 8},
        wrapperCol: { span: 14}
    };

    const timeFormat = 'HH:mm';

    const reorder = useCallback((list, startIndex, endIndex) => {
        const result = Array.from(list);
        let [removed] = result.splice(startIndex, 1);
        if(!isValid(removed)){
            removed = {};
        }
        result.splice(endIndex, 0, removed);
        setCitiesChanged(true);
        return result;
    }, [setCitiesChanged]);

    const onDragEnd = useCallback((result) => {
        // dropped outside the list
        if (!result.destination) {
          return;
        }
    
        const items = reorder(
          selectedCities,
          result.source.index,
          result.destination.index
        );
        onCallBackSetDirections([...items]); 
    }, [selectedCities, reorder, onCallBackSetDirections]);

    const isFareAvailable = useCallback((values, busSelected) => {
        let fareAvailable = false ; 
        if(isValid(values['fare'])){
            fareAvailable = true;
        }else{
            if(isValidArray(busSelected)){
                let seatGroupIds=getArrayfromString(busSelected.seat_group_ids,',');
                seatGroupIds.forEach(element => {
                  if(isValid(values[element])){
                    fareAvailable = true;
                  }
                });
            }
        }
        return fareAvailable;
    }, []);

    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        form.validateFields()
            .then((values) => {
                updateForm(Object.assign(formeDetails, values));
                if (endReached) {
                    let masterCityLength = selectedCities.length;
                    if (masterCityLength>=2){
                        var cityList = [];
                        selectedCities.map((city) => {
                            cityList.push(city.city_name);
                        })
                        // setLoading(true);
                        // Move to Add Stops step after successful city selection
                        if (setAddStop) {
                            setAddStop(true);
                        }
                        setHeaderStep(2);
                    }
                    else {
                        message.error("Please enter minimum of 2 cities")
                    }
                }
                else{
                    let fareAvailable = isFareAvailable(values,busSelected);
                    if(fareAvailable){
                        updateCurrent(current + 1);
                    }else{
                        message.error("Fare unavailable. Enable default fare / add seat group ids for bus.")
                    }
                }
            }).catch((error)=>{
                // Error handling
            });
    }, [form, updateForm, formeDetails, endReached, selectedCities, setAddStop, setHeaderStep, isFareAvailable, busSelected, updateCurrent, current]);

    const multicities = useMemo(() => {
        var citiesDiv = [];   
        let cityNum = 2;
        if(cityNum<=selectedCities.length){
            cityNum =  selectedCities.length + 1;    
        }

        for (let index = 0; index < cityNum; index++) {
            let disable;
            let defaultValue = null;
            if (index==0){
                disable= false;
            }
            else {
                disable = selectedCities.length==0?true:false;
            }
            if (isValid(selectedCities[index])){
                defaultValue = selectedCities[index].city_name;
            }
            citiesDiv.push(
                        <Draggable key={`item-${index}`} draggableId={`item-${index}`} index={index} type="TASK">
                            {(provided,snapshot) => (
                                <div
                                className="marginBottom paddingRight"
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                >
                                    <CitySelect
                                        masterCities= {masterCities}
                                        cityIndex={index}
                                        updateSelectedCity= {updateSelectedCity}
                                        disabled= {disable}
                                        defaultCity = {defaultValue}
                                        selectedMethod = "time"
                                        selectedCities = {selectedCities}
                                        isOrigin = {isValid(selectedCities[index]) && selectedCities[index].isOrigin}
                                        isDestination = {isValid(selectedCities[index]) && selectedCities[index].isDestination}
                                    />
                                </div>  
                            )}
                        </Draggable>
            )
        }
        return citiesDiv;
    }, [selectedCities, masterCities]);

    // Convert TimeMethodStops data format to Redux selectedStops format
    const convertStopsToReduxFormat = useCallback((citiesWithStops) => {
        const reduxStops = {};
        
        citiesWithStops.forEach(city => {
            const cityName = city.displayName || city.city;
            if (city.stops && city.stops.length > 0) {
                reduxStops[cityName] = {
                    city_name: cityName,
                    // Add city-level time and day
                    city_time: city.cityTime,
                    city_day: city.cityDay,
                    stops: city.stops.map(stop => ({
                        // Spread first so derived fields can't be overwritten by undefined
                        ...stop,
                        id: stop.selectedStopId || stop.id,
                        name: stop.displayName || stop.name,
                        // Canonical persisted time field used by later converters
                        stop_time: stop.timing ?? stop.stop_time ?? null,
                        day: stop.day,
                        isActive: stop.isActive,
                        isMainStop: isValid(stop.isMainStop)? stop.isMainStop: stop.is_main_stop,
                        tripClosePoint: stop.tripClosePoint,
                        phoneNumber: stop.phoneNumber,
                        landlineNumber: stop.landlineNumber,
                    }))
                };
            } else {
                // Handle cities without stops but with city-level time/day
                reduxStops[cityName] = {
                    city_name: cityName,
                    city_time: city.cityTime,
                    city_day: city.cityDay,
                    stops: []
                };
            }
        });
        
        return reduxStops;
    }, []);

    // Convert Redux selectedStops format to TimeMethodStops format
    const convertReduxToStopsFormat = useCallback((selectedStops, selectedCities) => {
        if (!selectedStops || Object.keys(selectedStops).length === 0) {
            return [];
        }

        return selectedCities.map((city, index) => {
            const cityName = city.city_name;
            const cityStops = selectedStops[cityName];
            
            return {
                city: cityName,
                displayName: cityName,
                isActive: true,
                isBoarding: city.isOrigin || false,
                isDrop: city.isDestination || false,
                // Add city-level time and day from Redux store
                cityTime: cityStops ? cityStops.city_time : null,
                cityDay: cityStops ? cityStops.city_day : 0,
                stops: cityStops && cityStops.stops ? cityStops.stops.map(stop => ({
                    selectedStopId: stop.id,
                    displayName: stop.name,
                    timing: stop.stop_time,
                    day: stop.day,
                    isActive: stop.isActive !== undefined ? stop.isActive : 1,
                    isMainStop: isValid(stop.isMainStop)? stop.isMainStop : stop.is_main_stop,
                    tripClosePoint: isValid(stop.tripClosePoint) ? stop.tripClosePoint : isValid(stop.is_trip_close_point) ? stop.is_trip_close_point : false,
                    phoneNumber: stop.phoneNumber,
                    landlineNumber: stop.landlineNumber,
                    isNewStop: false,
                    isStop: true,
                    // Add other necessary fields
                    ...stop
                })) : []
            };
        });
    }, []);

    // If addStop is true, show the TimeMethodStops component for managing stops
    if (addStop) {
        // Convert Redux selectedStops to TimeMethodStops format, or use excel route data
        const stopsDataToUse = Object.keys(selectedStops).length > 0 
            ? convertReduxToStopsFormat(selectedStops, selectedCities)
            : (excelRouteData ? excelRouteData.routeData : []);
        
        return (
            <div className={`${customClassName}`}>
                <div style={{ alignItems: 'center' }}>
                    <TimeMethodStops
                        selectedCities={selectedCities}
                        existingStops={stopsDataToUse}
                        temporaryCityFlow={isValid(temporaryFlowState) && temporaryFlowState.temporaryCityFlow === true}
                        temporaryCityName={isValid(temporaryFlowState) ? temporaryFlowState.newCity?.city_name : null}
                        onStopsUpdate={(stops) => {
                            // Convert TimeMethodStops format to Redux format and store
                            const reduxStops = convertStopsToReduxFormat(stops);
                            dispatch(setSelectedStops(reduxStops));
                        }}
                        onContinue={() => {
                            // Move to verification step
                            setShowVerifyPage(true);
                            setHeaderStep(3);
                        }}
                        customClassName={customClassName}
                    />
                </div>
            </div>
        );
    }

    return (
        <div style= {{alignItems: 'center'}}>
            <div className="create-trip-root">
                <div>
                    <h3>
                        {tripCityHeader}
                    </h3>
                </div>
                {checkActionAllowed(ACTION_CREATE_TRIP_FROM_EXCEL) && !isValid(tripScheduleId) && <RouteExcelComponent
                    masterCities={masterCities}
                    selectedCities={selectedCities}
                    updateSelectedCity={updateSelectedCity}
                    onCallBackSetDirections={onCallBackSetDirections}
                    setCitiesChanged={setCitiesChanged}
                    onRouteCreated={(routeData) => {
                        setExcelRouteData(routeData);
                        // Convert excel route data to Redux format and store
                        if (routeData.routeData && routeData.routeData.length > 0) {
                            const reduxStops = convertStopsToReduxFormat(routeData.routeData);
                            dispatch(setSelectedStops(reduxStops));
                        }
                    }}
                />}
                <Divider className="trip-divider"/>
                {/*<div className="create-trip-underline"></div>
                <p>Time method implementation will be different from map method.</p> */}
                {/* {multicities()} */}
                {!showSelectCity ? (
                    <>
                        <Form form={form} name="basic" initialValues={{trip_identifier: ''}} {...layout}>
                            <DragDropContext 
                                onDragEnd={onDragEnd}
                            >
                                <Droppable droppableId="droppable">
                                    {(provided,snapshot) => (
                                        <div
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                        className={snapshot.isDragging?"":"draggable-root"}
                                        >
                                            {multicities}
                                        </div>
                                    )}
                                </Droppable>
                            </DragDropContext>
                            <Divider className="trip-divider"/>
                            <Row justify="space-around">
                                <Button
                                    type="primary"
                                    onClick={(e) => {
                                        handleSubmit(e);
                                    }}
                                >
                                    Continue
                                </Button>
                            </Row>
                        </Form>
                        {isValidArray(selectedCities) && selectedCities.length >= 2 && (
                            <div style={{ marginTop: '20px' }}>
                                {addStopComponent}
                            </div>
                        )}
                    </>
                ) : null}
            </div>
        </div>
    )
} 